import { AfterViewInit, Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
@Component({
    selector: 'app-weekly-operational-hours-v2',
    templateUrl: './weekly-operational-hours-v2.component.html',
    styleUrls: ['./weekly-operational-hours-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WeeklyOperationalHoursV2Component implements OnInit, AfterViewInit {
  @Input() configData;
  @Input() frmGroup;
  
  intermediateForm: UntypedFormGroup;
  weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  hours = [];
  isSmallDevice : boolean;
  constructor(private fb: UntypedFormBuilder, private breakpointObserver:BreakpointObserver) { }
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.HandsetPortrait)
  .pipe(
    map(result => result.matches),
    shareReplay()
  );
  ngOnInit() {    
    this.generateAndsetValueToForm();
    if(this.isHandset$)
    {
      this.isSmallDevice = false;
    }
    else
    {
      this.isSmallDevice = true;
    }
  }
  
  generateAndsetValueToForm(){
    let formValue = this.frmGroup.get(this.configData.name).value;   
    this.intermediateForm = this.fb.group({
      sunday: this.fb.group({
        isPresent: [{ value: false, disabled: false }],
        from: [{ value: '', disabled: true}],
        to: [{ value: '', disabled: true}]
      }),
      monday: this.fb.group({
        isPresent: [true],
        from: [{ value: this.configData.fromTime, disabled: false }],
        to: [{ value: this.configData.toTime, disabled: false }]
      }),
      tuesday: this.fb.group({
        isPresent: [true],
        from: [{ value: this.configData.fromTime, disabled: false }],
        to: [{ value: this.configData.toTime, disabled: false }]
      }),
      wednesday: this.fb.group({
       isPresent: [true],
        from: [{ value: this.configData.fromTime, disabled: false }],
        to: [{ value: this.configData.toTime, disabled: false }]
      }),
      thursday: this.fb.group({
        isPresent: [true],
        from: [{ value: this.configData.fromTime, disabled: false }],
        to: [{ value: this.configData.toTime, disabled: false }]
      }),
      friday: this.fb.group({
        isPresent: [true],
        from: [{ value: this.configData.fromTime, disabled: false }],
        to: [{ value: this.configData.toTime, disabled: false }]
      }),
      saturday: this.fb.group({
        isPresent: [false],
        from: [{ value: '', disabled: true}],
        to: [{ value: '', disabled: true}]
      })
    })       
    if(formValue){
      Object.keys(formValue).forEach(key=>{
        if(formValue[key].isPresent != true){
          let form: UntypedFormGroup = this.intermediateForm.get(key) as UntypedFormGroup;
          form.get('from').disable();
          form.get('to').disable();
        } else if(formValue[key].isPresent == true){
          let form: UntypedFormGroup = this.intermediateForm.get(key) as UntypedFormGroup;
          form.get('from').enable();
          form.get('to').enable();
        }
      });      
    }
    for(let i=0; i < 12; i++){
      this.hours.push((i < 10 ? '0'+i.toString() : i.toString())+ ':' + '00 AM' );
      this.hours.push((i < 10 ? '0'+i.toString() : i.toString()) + ':' + '30 AM' );
    }
    for(let j=0; j < 12; j++){
      this.hours.push(( j == 0 ? '12' : (j < 10 ? '0'+j.toString() : j.toString())) + ':' + '00 PM' );
      this.hours.push((j == 0 ? '12' : (j < 10 ? '0'+j.toString() : j.toString())) + ':' + '30 PM' );
    }
    if(this.configData.disabled){
      this.intermediateForm.disable();
    }
  }

  ngAfterViewInit(){
    if(this.frmGroup.get(this.configData.name).value){
      this.intermediateForm.patchValue(this.frmGroup.get(this.configData.name).value);
    }
    this.frmGroup.get(this.configData.name).setValue(this.intermediateForm.getRawValue());
  }

  toggleEnable(event, formName, skipCtrl){
    event.stopPropagation();
    let form: UntypedFormGroup = this.intermediateForm.get(formName) as UntypedFormGroup;        
    Object.keys(form.controls).map(ctrl=>{      
        if(ctrl !== skipCtrl){
          if(event.target.checked == true){
            form.controls[ctrl].enable()            
          } else {
            form.controls[ctrl].disable();
          }          
        }      
    })    
    this.updateForm(event)
  }

  updateForm(e){
    e.stopPropagation();
    this.frmGroup.get(this.configData.name).patchValue(this.intermediateForm.getRawValue());
    this.frmGroup.markAsDirty(); //CP-5492
  }

  onSubmit() { 
    console.log(this.frmGroup.get(this.configData.name));
  }

  getControlByName(day: string, controlName: string): UntypedFormControl {
    const fg = this.intermediateForm.get(day) as UntypedFormGroup;
    return fg.get(controlName) as UntypedFormControl;
  }

}
